import React, { useCallback, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import ApplePayButton from 'common/components/ApplePayButton'
import { CheckoutContext } from 'artkive/contexts/CheckoutContext'
import braintree from 'artkive/utils/braintreeClient'

import { startApplePaySession } from './utils'

const ApplePay = ({ children, price, onAddressChange, onSubmit, setError, requestAddress, onClick, disabled }) => {
  const { braintreeClientToken } = useContext(CheckoutContext)
  const [braintreeApplePayInstance, setBraintreeApplePayInstance] = useState(null)

  const setupBraintree = async () => {
    try {
      const clientInstance = await braintree.client.create({
        authorization: braintreeClientToken,
      })
      const applePayInst = await braintree.applePay.create({
        client: clientInstance,
      })

      setBraintreeApplePayInstance(applePayInst)
    } catch (err) {
      console.error('Failed to initialize Braintree Apple Pay:', err)
    }
  }

  const payClickHandler = useCallback(async () => {
    if (disabled) return
    if (typeof onClick === 'function') {
      const isValid = await onClick()
      if (isValid === false) return
    }

    startApplePaySession(braintreeApplePayInstance, requestAddress, price, onAddressChange, onSubmit, setError)
  }, [
    disabled,
    requestAddress,
    price,
    onSubmit,
    onAddressChange,
    setError,
    onClick,
    braintreeApplePayInstance,
  ])

  useEffect(() => {
    setupBraintree()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ApplePayButton
      theme={'dark'}
      onClick={payClickHandler}
      disabled={disabled || !braintreeApplePayInstance}
    >
      {children}
    </ApplePayButton>
  )
}

ApplePay.propTypes = {
  price: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  requestAddress: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

ApplePay.defaultProps = {
  children: null,
  requestAddress: false,
  onClick: null,
  disabled: false,
}

export default ApplePay
